const TOKEN_NAME = process.env.TOKEN_NAME || 'access-token'
const API = process.env.API_URL || 'localhost:4000'

module.exports = {
    TOKEN_NAME,
    API,
    ...require('./auth'),
    ...require('./networks')
}
